










import { Component, Vue, Prop } from "vue-property-decorator";
import { INews } from "@/api/types";
@Component
export default class Index extends Vue {
  @Prop()
  newsData!: INews;

  itemClick() {
    this.$emit("itemClick", this.newsData);
  }
}
